// @ts-nocheck
/**
 * Product Configurator - Using Shopify Product Taxonomy
 */

(function() {
  'use strict';

  const configurators = document.querySelectorAll('.product-configurator');
  
  configurators.forEach(initConfigurator);

  function initConfigurator(section) {
    let selectedDesign = null;
    let selectedType = null;
    let selectedTypeTaxonomyId = null; // Store the taxonomy ID
    let allProductTypes = new Map(); // Map of display name -> taxonomy ID
    let designTypeMap = {}; // Map of design -> array of {name, taxonomyId}

    const designButtons = section.querySelectorAll('.design-option');
    const typeButtonsContainer = section.querySelector('.type-buttons');
    const resultsContainer = section.querySelector('.configurator-results');
    const resultsGrid = section.querySelector('.results-grid');
    const resultsLoading = section.querySelector('.results-loading');
    const resultsDescription = section.querySelector('.results-description');
    const resetButton = section.querySelector('.results-reset');
    const resetAllButton = section.querySelector('.configurator-reset-all');

    console.log('=== CONFIGURATOR INITIALIZED ===');

    // Initialize: Fetch all product types across all collections
    initializeProductTypes();

    function initializeProductTypes() {
      typeButtonsContainer.innerHTML = '<p class="loading-types" style="padding: 12px; color: #666;">Loading product types...</p>';
      
      // Fetch the main collection to get all available product types
      fetch('/collections/all')
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Extract all product types with their taxonomy IDs
          const typesMap = extractProductTypesFromFilters(doc);
          allProductTypes = typesMap;
          
          console.log('All product types found:', Object.fromEntries(allProductTypes));
          
          // Now fetch available types for each design collection
          return fetchTypesForAllDesigns();
        })
        .then(() => {
          console.log('Design-Type map:', designTypeMap);
          displayProductTypes(allProductTypes);
        })
        .catch(error => {
          console.error('Error initializing:', error);
          typeButtonsContainer.innerHTML = '<p class="error-message" style="padding: 12px; color: #d32f2f;">Could not load product types</p>';
        });
    }

    function fetchTypesForAllDesigns() {
      const designHandles = Array.from(designButtons).map(btn => btn.dataset.design);
      
      const promises = designHandles.map(design => 
        fetch(`/collections/${design}`)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const typesMap = extractProductTypesFromFilters(doc);
            
            // Store as array of objects with name and taxonomyId
            designTypeMap[design] = Array.from(typesMap.entries()).map(([name, id]) => ({
              name: name,
              taxonomyId: id
            }));
            
            console.log(`Types for ${design}:`, designTypeMap[design]);
          })
          .catch(error => {
            console.error(`Error fetching ${design}:`, error);
            designTypeMap[design] = [];
          })
      );
      
      return Promise.all(promises);
    }

    function extractProductTypesFromFilters(doc) {
      const typesMap = new Map(); // Map of display name -> taxonomy ID
      
      console.log('Extracting product types with taxonomy IDs...');
      
      // Method 1: Look for the specific Facet-Details element with category in the ID
      const categoryFacet = doc.querySelector('[id*="Facet-Details"][id*="category"]') ||
                           doc.querySelector('[id*="Facet-Details"][id*="filter-p-t"]');
      
      if (categoryFacet) {
        console.log('✓ Found category facet via ID:', categoryFacet.id);
        
        const inputs = categoryFacet.querySelectorAll('input[type="checkbox"], input[type="radio"]');
        console.log(`  Found ${inputs.length} filter inputs`);
        
        inputs.forEach(input => {
          // Get the taxonomy ID from the input value
          const taxonomyId = input.value;
          
          // Get the display label
          const label = categoryFacet.querySelector(`label[for="${input.id}"]`);
          
          if (label && taxonomyId && taxonomyId !== 'on') {
            const text = label.textContent.trim();
            const cleanText = text.replace(/\s*\(\d+\)\s*$/, '').trim();
            
            console.log(`    Label: "${cleanText}" -> Taxonomy ID: "${taxonomyId}"`);
            
            if (cleanText && 
                cleanText.toLowerCase() !== 'category' && 
                cleanText.toLowerCase() !== 'type' &&
                cleanText.length > 0) {
              typesMap.set(cleanText, taxonomyId);
              console.log(`      ✓ Added: "${cleanText}" with ID "${taxonomyId}"`);
            }
          }
        });
      } else {
        console.log('Category facet not found via ID, trying other methods...');
      }
      
      // Method 2: Look for any details/summary with "Category" text
      if (typesMap.size === 0) {
        console.log('Trying Method 2: details/summary elements');
        
        const detailsElements = doc.querySelectorAll('details');
        console.log(`  Found ${detailsElements.length} details elements`);
        
        detailsElements.forEach((details, idx) => {
          const summary = details.querySelector('summary');
          if (summary) {
            const summaryText = summary.textContent.trim().toLowerCase();
            console.log(`  Details ${idx}: "${summaryText}"`);
            
            if (summaryText.includes('category')) {
              console.log('    ✓ Found Category filter!');
              
              const inputs = details.querySelectorAll('input[type="checkbox"], input[type="radio"]');
              inputs.forEach(input => {
                const taxonomyId = input.value;
                const label = details.querySelector(`label[for="${input.id}"]`);
                
                if (label && taxonomyId && taxonomyId !== 'on') {
                  const cleanText = label.textContent.trim().replace(/\s*\(\d+\)\s*$/, '').trim();
                  if (cleanText && cleanText.toLowerCase() !== 'category') {
                    typesMap.set(cleanText, taxonomyId);
                    console.log(`      ✓ Added: "${cleanText}" with ID "${taxonomyId}"`);
                  }
                }
              });
            }
          }
        });
      }
      
      // Method 3: Look for inputs with filter.p.t.category in the name
      if (typesMap.size === 0) {
        console.log('Trying Method 3: filter inputs by name');
        
        const filterInputs = doc.querySelectorAll('input[name*="filter.p.t.category"]');
        console.log(`  Found ${filterInputs.length} taxonomy filter inputs`);
        
        filterInputs.forEach(input => {
          const taxonomyId = input.value;
          const label = doc.querySelector(`label[for="${input.id}"]`);
          
          if (label && taxonomyId && taxonomyId !== 'on') {
            const cleanText = label.textContent.trim().replace(/\s*\(\d+\)\s*$/, '').trim();
            if (cleanText) {
              typesMap.set(cleanText, taxonomyId);
              console.log(`    ✓ Added from input: "${cleanText}" with ID "${taxonomyId}"`);
            }
          }
        });
      }
      
      console.log('Final extracted types map:', Object.fromEntries(typesMap));
      return typesMap;
    }

      function displayProductTypes(typesMap, highlightAvailable = null) {
        if (typesMap.size === 0) {
          typeButtonsContainer.innerHTML = '<p class="no-types" style="padding: 12px; color: #999;">No product types available</p>';
          return;
        }

        // Get the button style from the section data attribute
        typeButtonsContainer.innerHTML = '';
        const sortedTypes = Array.from(typesMap.keys()).sort();

        sortedTypes.forEach(typeName => {
          const taxonomyId = typesMap.get(typeName);
          
          const button = document.createElement('button');
          button.className = 'type-option'; // ← REMOVED button classes
          button.dataset.type = typeName;
          button.dataset.taxonomyId = taxonomyId;
          button.setAttribute('aria-label', `Select ${typeName}`);
          button.textContent = typeName;

        // Disable types not available in selected design
        if (highlightAvailable) {
          const availableNames = highlightAvailable.map(t => t.name);
          if (!availableNames.includes(typeName)) {
            button.disabled = true;
            button.style.opacity = '0.3';
            button.style.cursor = 'not-allowed';
          }
        }
        
        // Restore active state if this was the selected type
        if (selectedType === typeName) {
          button.classList.add('active');
        }
        
        button.addEventListener('click', function() {
          if (this.disabled) return;
          
          selectedType = this.dataset.type;
          selectedTypeTaxonomyId = this.dataset.taxonomyId;
          console.log('Type selected:', selectedType, 'Taxonomy ID:', selectedTypeTaxonomyId);
          
          // Update active state on all type buttons
          section.querySelectorAll('.type-option').forEach(b => b.classList.remove('active'));
          this.classList.add('active');
          
          if (selectedDesign) {
            fetchProducts(selectedDesign, selectedType, selectedTypeTaxonomyId);
          } else {
            filterDesignsByType(selectedType);
          }
        });

        typeButtonsContainer.appendChild(button);
      });
    }

    function filterDesignsByType(typeName) {
      const availableDesigns = Object.keys(designTypeMap).filter(design => {
        const types = designTypeMap[design];
        return types.some(t => t.name === typeName);
      });
      
      console.log(`Designs with ${typeName}:`, availableDesigns);
      
      designButtons.forEach(btn => {
        const design = btn.dataset.design;
        if (availableDesigns.includes(design)) {
          btn.disabled = false;
          btn.style.opacity = '1';
          btn.style.cursor = 'pointer';
        } else {
          btn.disabled = true;
          btn.style.opacity = '0.3';
          btn.style.cursor = 'not-allowed';
        }
      });
    }

    designButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        if (this.disabled) return;
        
        selectedDesign = this.dataset.design;
        console.log('Design selected:', selectedDesign);
        
        // Update active state
        designButtons.forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        
        // Update available types and re-render buttons with availability
        const availableTypes = designTypeMap[selectedDesign] || [];
        
        // Convert to Map for displayProductTypes
        const availableTypesMap = new Map();
        availableTypes.forEach(t => {
          availableTypesMap.set(t.name, t.taxonomyId);
        });
        
        displayProductTypes(allProductTypes, availableTypes);
        
        // If a type is already selected, fetch products
        if (selectedType && selectedTypeTaxonomyId) {
          fetchProducts(selectedDesign, selectedType, selectedTypeTaxonomyId);
        }
      });
    });

    // Reset handler function
    function handleReset() {
      console.log('Reset clicked');
      selectedDesign = null;
      selectedType = null;
      selectedTypeTaxonomyId = null;
      
      // Reset design buttons
      designButtons.forEach(b => {
        b.classList.remove('active');
        b.disabled = false;
        b.style.opacity = '1';
        b.style.cursor = 'pointer';
      });
      
      // Reset type buttons - show all types
      displayProductTypes(allProductTypes);
      
      // Hide results
      if (resultsContainer) {
        resultsContainer.style.display = 'none';
      }
      if (resultsGrid) {
        resultsGrid.innerHTML = '';
      }
    }

    // Attach click handlers to both buttons
    if (resetButton) {
      resetButton.addEventListener('click', handleReset);
    }

    if (resetAllButton) {
      resetAllButton.addEventListener('click', handleReset);
    }

    function fetchProducts(design, typeName, taxonomyId) {
      console.log(`Fetching products: design=${design}, type=${typeName}, taxonomyId=${taxonomyId}`);
      
      resultsContainer.style.display = 'block';
      resultsLoading.style.display = 'block';
      resultsGrid.innerHTML = '';
      
      // Get the design name from the button
      const designButton = section.querySelector(`[data-design="${design}"]`);
      let designName = 'this collection';
      
      if (designButton) {
        const rawDesignName = designButton.dataset.designName;
        designName = rawDesignName.replace(/[\[\]"]/g, '').trim();
      }
      
      if (resultsDescription) {
        resultsDescription.textContent = `Showing ${typeName} products in ${designName}`;
      }

      // Use the taxonomy ID filter that Shopify uses
      const params = new URLSearchParams({
        'filter.p.t.category': taxonomyId
      });

      const collectionUrl = `/collections/${design}?${params.toString()}`;
      console.log('Fetching from URL:', collectionUrl);

      fetch(collectionUrl)
        .then(response => response.text())
        .then(html => {
          resultsLoading.style.display = 'none';
          parseAndDisplayProducts(html);
        })
        .catch(error => {
          console.error('Fetch error:', error);
          resultsLoading.style.display = 'none';
          resultsGrid.innerHTML = '<p class="error-message" style="text-align: center; padding: 40px; color: #d32f2f;">Something went wrong. Please try again.</p>';
        }); 
    }

    function parseAndDisplayProducts(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Find the product grid - try multiple selectors
      const productGrid = doc.querySelector('.product-grid') || 
                        doc.querySelector('[data-products]') ||
                        doc.querySelector('.collection-product-grid') ||
                        doc.querySelector('.grid--products') ||
                        doc.querySelector('.collection__products') ||
                        doc.querySelector('#product-grid') ||
                        doc.querySelector('.product-list');
      
      console.log('Product grid found:', !!productGrid);
      
      if (productGrid && productGrid.children.length > 0) {
        console.log('Product grid children:', productGrid.children.length);
        
        // Since we're using taxonomy filtering, the products should already be filtered
        // Just display them directly
        resultsGrid.innerHTML = productGrid.innerHTML;

        // Copy product grid classes so Dwell's scoped CSS applies correctly
        // (hover states, quick add positioning, badge sizing, etc.)
        if (productGrid.className) {
          productGrid.classList.forEach(cls => {
            if (!resultsGrid.classList.contains(cls)) {
              resultsGrid.classList.add(cls);
            }
          });
        }
        
        // Re-initialize theme JS if needed
        if (typeof window.theme !== 'undefined' && window.theme.initProductGrid) {
          window.theme.initProductGrid(resultsGrid);
        }
      } else {
        resultsGrid.innerHTML = '<p class="no-results" style="text-align: center; padding: 60px 20px; color: #666; font-size: 1.1rem;">No products found with this combination. Try a different selection!</p>';
      }
    }
  }
})();
